/* ==========================================================
   REBELLE — page produit (amélioration progressive)
   Sélecteur de variante (pastilles) qui pilote un <select name="id">
   (source de vérité, repli sans JS), galerie, quantité, et ajout Ajax
   qui délègue à window.RebelleCart. Si le JS échoue, {% form 'product' %}
   soumet nativement.
   ========================================================== */
(function () {
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var form = root.querySelector('form');
    var dataEl = root.querySelector('[data-variants]');
    if (!form || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = form.querySelector('[data-variant-select]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
    var addText = addBtn ? addBtn.getAttribute('data-add-text') : '';
    var soldText = addBtn ? addBtn.getAttribute('data-soldout-text') : '';

    function currentSelection() {
      var sel = [];
      root.querySelectorAll('[data-option]').forEach(function (grp) {
        var i = parseInt(grp.dataset.optionIndex, 10);
        var checked = grp.querySelector('input[data-option-index]:checked');
        sel[i] = checked ? checked.value : null;
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }

    function updateSelectedLabels(sel) {
      root.querySelectorAll('[data-selected-value]').forEach(function (el) {
        var i = parseInt(el.dataset.selectedValue, 10);
        if (sel[i] != null) el.textContent = sel[i];
      });
    }

    function updatePrice(v) {
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        if (v.compare_at) { compareEl.textContent = v.compare_at; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
    }

    function activateMedia(mediaId) {
      var main = root.querySelector('[data-main-image]');
      var thumb = root.querySelector('[data-thumb][data-media-id="' + mediaId + '"]');
      if (main && thumb) {
        if (thumb.dataset.src) main.src = thumb.dataset.src;
        if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
      }
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.mediaId === mediaId ? 'true' : 'false');
      });
    }

    function updateAddButton(v) {
      if (!addBtn) return;
      var ok = v && v.available;
      addBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = ok ? addText : soldText;
    }

    // Une valeur d'option est désactivée (+ barrée) si aucune variante disponible
    // ne la combine avec les autres choix en cours.
    function updateAvailability(sel) {
      root.querySelectorAll('[data-option]').forEach(function (grp) {
        var i = parseInt(grp.dataset.optionIndex, 10);
        grp.querySelectorAll('input[data-option-index]').forEach(function (input) {
          var ok = variants.some(function (v) {
            if (!v.available) return false;
            return v.options.every(function (o, idx) {
              if (idx === i) return o === input.value;
              return sel[idx] == null || o === sel[idx];
            });
          });
          if (!input.checked) input.disabled = !ok;
          var label = input.closest('label');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function sync() {
      var sel = currentSelection();
      var v = findVariant(sel);
      if (select && v) select.value = v.id;
      updateSelectedLabels(sel);
      updatePrice(v);
      if (v && v.media_id != null) activateMedia(String(v.media_id));
      updateAddButton(v);
      updateAvailability(sel);
    }

    root.querySelectorAll('input[data-option-index]').forEach(function (input) {
      input.addEventListener('change', sync);
    });
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { activateMedia(t.dataset.mediaId); });
    });

    var qty = form.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.dir, 10));
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.RebelleCart) return; // pas de JS panier → soumission native
      e.preventDefault();
      if (addBtn) addBtn.classList.add('is-loading');
      var done = window.RebelleCart.add(new FormData(form));
      if (done && done.then) {
        done.then(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
      } else if (addBtn) {
        addBtn.classList.remove('is-loading');
      }
    });

    // Produit multi-variantes seulement : sinon le <select> (repli) suffit et
    // le bouton d'ajout reste tel que rendu par Liquid.
    if (root.querySelector('[data-option]')) sync();
  });
})();
